<template>
  <b-modal
    ref="resellerServers"
    centered
    size="lg"
    title="List of available reseller servers"
    scrollable
    hide-footer
    @hidden="unselectReseller(), clearResellerServers()">

    <no-data-found
      v-if="resellerServersEmpty"
      text="This reseller don't have any servers yet" />

    <div
      v-else
      class="accordion mb-8">
      <b-card
        v-for="group in resellerServers"
        :key="group.country_code"
        class=""
        body-class="p-0">
        <b-card-header
          v-b-toggle="'group' + group.country_code"
          header-tag="header"
          class="pt-4 pb-4 pl-4 pr-6 d-flex align-items-center"
          role="tab">
          <img
            :src="countryFlag(group.country_code)"
            :alt="group.country_code"
            class="w-20px mr-2 no-select rounded-sm bg-light border border-light rounded-sm rounded-sm" />
          <span class="d-inline-block line-height-xl">
            <span class="font-weight-bold mr-2">{{ countryName(group.country_code) }}</span>
            <span class="font-size-sm font-weight-normal text-muted">({{ group.servers.length }} {{ 'server' | pluralize(group.servers.length) }})</span>
          </span>
          <i class="fas fa-chevron-down ml-auto fa-sm text-muted"></i>
        </b-card-header>
        <b-collapse
          :id="'group' + group.country_code"
          accordion="my-accordion"
          role="tabpanel">
          <b-card-body class="pb-2 px-4">
            <b-table
              :items="group.servers"
              :fields="fields"
              stacked="md"
              show-empty
              responsive
              class="mb-0">

              <!-- custom headings -->
              <template #head(ip)>
                <div class="ml-2">IP</div>
              </template>

              <!-- custom cells -->
              <template #cell(location)="data">
                <span
                  class="d-inline-block text-truncate"
                  style="max-width: 300px;">{{ data.item.location }}</span>
              </template>
              <template #cell(ip)="data">
                <b-button
                  v-wave
                  size="sm"
                  variant="hover-light-info"
                  class="font-weight-normal py-1 px-2"
                  @click="copyInput(`#copy-ip-${data.item._id}`)">
                  {{ data.item.ip }}
                  <i class="far fa-copy fa-sm ml-2 p-0" />
                </b-button>
                <b-input
                  :id="`copy-ip-${data.item._id}`"
                  :value="data.item.ip"
                  class="position-absolute"
                  style="opacity: 0.01; z-index: -1000; left: -9999px;" />
              </template>
              <template #cell(vpn_servers)="data">
                <div class="d-flex justify-content-end">
                  <div class="table-grid-items align-right">
                    <span
                      v-for="vpnServer in data.item.vpn_servers"
                      :key="vpnServer._id"
                      v-b-tooltip.hover
                      :title="vpnServer.name"
                      class="svg-icon svg-icon-sm cursor-help">
                      <inline-svg
                        :src="`media/svg/icons/VPN/${vpnServer.code}.svg`"
                        class="svg-icon m-0" />
                    </span>
                  </div>
                </div>
              </template>
            </b-table>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>

    <reseller-details-plate />
  </b-modal>
</template>

<script>
import { UNSELECT_RESELLER, CLEAR_RESELLER_SERVERS } from '@/core/services/store/resellers.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import {
  showModal,
  hideModal,
  copyInput,
  showToast
} from '@/core/utils'
import ResellerDetailsPlate from './ResellerDetailsPlate.vue'

export default {
  name: 'ModalResellerServers',
  components: {
    ResellerDetailsPlate
  },
  data() {
    return {
      fields: [
        {
          label: 'Location',
          key: 'location',
          class: ['align-middle', 'text-nowrap'],
          thStyle: 'width: 33%;',
        },
        {
          label: 'IP',
          key: 'ip',
          class: ['align-middle', 'text-nowrap', 'font-size-sm', 'pl-0'],
          thStyle: 'width: 33%;',
        },
        {
          label: 'VPN Servers',
          key: 'vpn_servers',
          class: ['align-middle', 'text-md-right', 'text-nowrap', 'pr-5'],
          thStyle: 'width: 33%;',
        },
      ],

      showModal,
      hideModal,
      copyInput,
      showToast,
    }
  },
  computed: {
    ...mapGetters([
      'countryFlag',
      'countryName',

      'selectedReseller',
      'selectedResellerId',
      'resellerServers',
      'resellerServersEmpty',
      'resellersResponses',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    unselectReseller() {
      this.$store.commit(UNSELECT_RESELLER)
    },

    clearResellerServers() {
      this.$store.commit(CLEAR_RESELLER_SERVERS)
    },
  }
}
</script>
